// extracted by mini-css-extract-plugin
export default {"container":"IdentityCardNumberStep_container__jW0zV","title":"IdentityCardNumberStep_title__QB7jM","description":"IdentityCardNumberStep_description__0M5x-"};